import { Repeat } from "lib/@components/repeat"
import { RateCardTag } from "./rate-card-tag"

export function RateCardAutocompleteTags(value, getTagProps) {
    return <Repeat list={value} item={<RateCardTag getTagProps={getTagProps} />} />
}
